import {
  SET_SURROUNDINGID,
  DELETE_SURROUNDINGID,
} from './actions';

const initState = {id: 1};

const surrounding= (state = initState, action) => {
  switch (action.type) {
  case SET_SURROUNDINGID:
    return {
      ...state,
      ...action.id,
    };
  case DELETE_SURROUNDINGID:
    return {};
  default:
    return state;
  }
};

export default surrounding;



// WEBPACK FOOTER //
// ./src/redux/surrounding/reducer.js